
import Config from "../config";
import {FilterModel,
        FilterJSON,
        FilterFactory} from '../models/modelsFilter';
import {ScreenElementChartModel,
        ScreenElementChartFactory,
        ScreenElementChartJSON} from '../models/modelsDashboard';

export type ChartResponseType = {data: any}

export const getChart = async (authToken: string,
                               chartUuid: string,
                               filters: FilterModel[]): Promise<ChartResponseType> => {
    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/chart/get/${chartUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const filterFactory = new FilterFactory();
      const filterJSON = filters.map((thisFilter: FilterModel) => filterFactory.toJSON(thisFilter))

      const body = {'chart_uuid': chartUuid,
                    'filters': filterJSON}

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();
      if(!data){
          throw new Error("Unhandled error")
      }

      const thisChart = new ScreenElementChartFactory().fromJSON(data)

      const thisPromise: ChartResponseType = {data: thisChart}

      return thisPromise

    } catch (error){
      throw new Error(`Error when fetching chart: ${(error as Error).message}`)
    }
}
